import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="countdown"
export default class extends Controller {
  static targets = ["timer"];

  static values = { date: String };

  connect() {
    this.start();
  }

  start() {
    this.update();

    this.timerValue = setInterval(() => {
      this.update();
    }, 1000);
  }

  update() {
    const now = new Date().getTime();
    const countdownDate = new Date(this.dateValue).getTime();
    const distance = countdownDate - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const rtf = new Intl.RelativeTimeFormat(navigator.language, {
      numeric: "always",
      style: "short",
    });
    let timeString = "";
    if (days > 0)
      timeString += rtf.format(days, "day").replace("in ", "") + " ";
    if (hours > 0)
      timeString += rtf.format(hours, "hour").replace("in ", "") + " ";
    if (minutes > 0)
      timeString += rtf.format(minutes, "minute").replace("in ", "") + " ";
    timeString += rtf.format(seconds, "second").replace("in ", "");

    this.timerTarget.textContent = timeString;

    if (distance < 0) {
      this.handleExpiredTimer();
    }
  }

  handleExpiredTimer() {
    clearInterval(this.timerValue);
    const formatter = new Intl.RelativeTimeFormat(navigator.language, {
      style: "short",
    });
    this.timerTarget.innerHTML = formatter.format(0, "second");
  }
}
